module.exports = __webpack_public_path__ + "static/media/audit_green.8d454fc5.png";